module.exports = __webpack_public_path__ + "static/media/levels_4_3.421a39ff.svg";